import Axios from 'axios'
import {activityDiscountUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_discounts (context) {
    Axios.get(activityDiscountUrls.getAllActivityDiscounts).then(function (response) {
      context.commit('GET_ALL_ACTIVITY_DISCOUNTS', response.data)
    })
  },
  get_activity_discounts (context, publicId) {
    Axios.get(activityDiscountUrls.getActivityDiscounts + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_DISCOUNTS', response.data)
    }).catch(function () {
      context.commit('GET_ACTIVITY_DISCOUNTS', [])
    })
  },
  get_deleted_activity_discounts (context) {
    Axios.get(activityDiscountUrls.getDeletedActivityDiscount).then(function (response) {
      context.commit('GET_DELETED_ACTIVITY_DISCOUNTS', response.data)
    })
  },
  get_activity_discount (context, publicId) {
    Axios.get(activityDiscountUrls.getActivityDiscount + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_DISCOUNT', response.data)
    })
  },
  post_activity_discount (context, data) {
    Axios.post(activityDiscountUrls.postActivityDiscount, data).then(function () {
      context.dispatch('get_activity_discounts', data.inventory_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  update_activity_discount (context, data) {
    Axios.post(activityDiscountUrls.editActivityDiscount, data).then(function () {
      context.dispatch('get_all_activity_discounts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  delete_activity_discount (context, data) {
    Axios.post(activityDiscountUrls.deleteActivityDiscount + data.public_id, data).then(function (response) {
      context.dispatch('get_activity_discounts', data.inventory_id)
    })
  },
  restoreActivityDiscount (context, publicId) {
    Axios.get(activityDiscountUrls.restoreActivityDiscount + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITY_DISCOUNTS', response.data)
      router.push({
        name: 'Module.ActivityDiscounts'
      })
    })
  }
}
